module.exports = __webpack_public_path__ + "img/filled-cabinet.609a7541.svg";